// @ts-check
import React from "react"
import { ReactComponent as LightbulbIcon } from "../../design/assests/images/icons/lightbulb2.svg"

function AikaTipsFAB({ ...props }) {
  return (
    <button className="tip-icon-trigger-fab" {...props}>
      <LightbulbIcon fill="var(--surface-shadow__dark)" />
    </button>
  )
}

export default AikaTipsFAB
